import { useEffect, useState } from 'react';
import { UserService } from '../services/user/userService';

let cachedBlockedEntryIds: string[] | null = null;
let fetchPromise: Promise<string[]> | null = null;

async function fetchBlockedEntryProductStatuses(): Promise<string[]> {
    if (cachedBlockedEntryIds !== null) {
        return cachedBlockedEntryIds;
    }

    if (fetchPromise) {
        return fetchPromise;
    }

    fetchPromise = (async () => {
        try {
            const service = new UserService();
            const response = await service.getCompanyConfigurationInfo();
            const ids = response.getResponseData()?.data?.blockedContractProductStatuses ?? [];
            cachedBlockedEntryIds = ids;
            return ids;
        } finally {
            fetchPromise = null;
        }
    })();

    return fetchPromise;
}

export const invalidateBlockedEntryProductStatusesCache = () => {
    cachedBlockedEntryIds = null;
};

const useBlockedEntryProductStatuses = (): string[] => {
    const [blockedEntryIds, setBlockedEntryIds] = useState<string[]>([]);

    useEffect(() => {
        let cancelled = false;

        fetchBlockedEntryProductStatuses()
            .then((ids) => {
                if (!cancelled) {
                    setBlockedEntryIds(ids);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setBlockedEntryIds([]);
                }
            });

        return () => {
            cancelled = true;
        };
    }, []);

    return blockedEntryIds;
};

export default useBlockedEntryProductStatuses;
